export const types = ['en', 'vn'];
